import React from 'react';

const DropdownLensIcon = (props) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5 20C9.35786 20 6 16.6421 6 12.5C6 8.35786 9.35786 5 13.5 5C17.6421 5 21 8.35786 21 12.5C21 14.4805 20.2324 16.2816 18.9784 17.6222L22.7809 22.3753C23.1259 22.8066 23.056 23.4359 22.6247 23.7809C22.1934 24.1259 21.5641 24.056 21.2191 23.6247L17.4304 18.8888C16.2875 19.5935 14.9412 20 13.5 20ZM13.5 18C16.5376 18 19 15.5376 19 12.5C19 9.46243 16.5376 7 13.5 7C10.4624 7 8 9.46243 8 12.5C8 15.5376 10.4624 18 13.5 18Z"
      fill="#2C2543"
      {...props}
    />
  </svg>
);

export default DropdownLensIcon;
